export function* range(to, from = 0) {
  for (let i = from; i < to; i++) {
    yield i;
  }
}
